module.exports = __webpack_public_path__ + "static/img/reset_password.09c6bf7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/reset_password.svg
// module id = 1336
// module chunks = 1